import React, { useContext, useMemo } from 'react';
import { debounce } from 'lodash';
import { Descendant } from 'slate';
import { CustomEditor, CustomParagraph } from '../../../models/slate-editor';
import { Editable, Slate } from 'slate-react';
import { RenderSlateElement } from '../TextEditor/RenderSlateElement';
import { PostEditorContext } from '../states/PostEditorProvider';
import { PostEditorGroupDataContext } from '../states/PostEditorGroupDataProvider';
import { ActiveCustomizeIndexContext } from '../states/ActiveCustomizeIndexProvider';
import { PostEditorFirstCommentUpdateAction } from '../states/PostEditorActions';
import { typeGuards } from '../TextEditor/helpers/typeGuards';
import { RenderSlatePlaceholder } from '../TextEditor/RenderSlatePlaceholder';

export type FirstCommentEditorViewProps = {
  //
  editor: CustomEditor;
  firstComment: CustomParagraph[];
};

export const FirstCommentEditorView = (props: FirstCommentEditorViewProps): JSX.Element => {
  const { editor, firstComment } = props;
  const { state, dispatch } = useContext(PostEditorContext);
  const [tabsState] = useContext(PostEditorGroupDataContext);
  const { postGroupIndex } = tabsState;
  const customizeIndex = useContext(ActiveCustomizeIndexContext);
  const postGroup = state.postGroups[postGroupIndex];
  const { customizeContentPerProfile } = postGroup;

  const updateText = useMemo<(payload: PostEditorFirstCommentUpdateAction['payload']) => void>(
    () => (payload: PostEditorFirstCommentUpdateAction['payload']) => {
      dispatch({ type: 'firstCommentUpdate', payload });
    },
    [dispatch]
  );

  return (
    <Slate
      editor={editor}
      value={firstComment}
      onChange={debounce((v: Descendant[]) => {
        if (!typeGuards.isCustomParagraphArrayGuard(v)) throw new Error('value is not CustomParagraph array');
        const text = v;
        updateText({
          postGroupIndex,
          customizeIndex,
          customizeContentPerProfile,
          text
        });
      }, 400)}>
      <Editable
        placeholder={'Type your text here...'}
        renderElement={RenderSlateElement}
        renderPlaceholder={RenderSlatePlaceholder}
      />
    </Slate>
  );
};
